export const ENABLE_POINTS_UI =
  import.meta.env.VITE_ENABLE_POINTS_UI === "true";
